export const {
  REACT_APP_SENTRY_DSN: SENTRY_DSN,
  REACT_APP_GA_TRACKING_ID: GOOGLE_ANALYTICS_TRACKING_ID,
} = process.env;
